import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from '@aipb/gulliver/frame/feature-dashboard';
import { ZipHistoryTableComponent } from '../zip-history-table/zip-history-table.component';
import { ZipManagerRepository, ZipManagerService } from '@aipb/gulliver/zip-manager/data-access';
import { ZipHistoryItem } from '@aipb/gulliver/dropbox/model';
import { ZipHistoryItemDialogService } from '../zip-history-item-dialog';
import { ZipDownloadService } from '../zip-download.service';
import { ZipCopyService } from '../zip-copy.service';
import { ZipOpenService } from '../zip-open.service';
import { ZipSearchService } from '../zip-search.service';
import { ZipRenameService } from '../zip-rename.service';
import { mergeMap } from 'rxjs';
import { ZipDeleteService } from '../zip-delete.service';

@Component({
  selector: 'zm-dashboard-page',
  standalone: true,
  imports: [CommonModule, DashboardComponent, ZipHistoryTableComponent],
  templateUrl: './dashboard-page.component.html',
  styleUrl: './dashboard-page.component.scss'
})
export class DashboardPageComponent implements OnInit {
  private service = inject(ZipManagerService);
  private repository = inject(ZipManagerRepository);
  items$ = this.repository.filteredItems$;
  loading$ = this.repository.loading$;
  private zipDownload = inject(ZipDownloadService);
  private zipHistoryItemDialog = inject(ZipHistoryItemDialogService);
  private zipCopy = inject(ZipCopyService);
  private zipOpen = inject(ZipOpenService);
  private zipSearch = inject(ZipSearchService);
  private zipRename = inject(ZipRenameService);
  private zipDelete = inject(ZipDeleteService);

  ngOnInit() {
    this.service.fetchZipHistory().subscribe();
  }

  onDownload(item: ZipHistoryItem) {
    this.zipDownload.download(item);
  }

  onDetail(item: ZipHistoryItem) {
    this.zipHistoryItemDialog.open(item.id);
  }

  onOpen(item: ZipHistoryItem) {
    this.zipOpen.open(item);
  }

  onCopy(item: ZipHistoryItem) {
    this.zipCopy.copy(item);
  }

  onSearch(item: ZipHistoryItem) {
    this.zipSearch.search(item);
  }

  onRename(item: ZipHistoryItem) {
    this.zipRename
      .rename(item)
      .pipe(mergeMap(() => this.service.fetchZipHistory()))
      .subscribe();
  }

  onFilterByName(filterByName: string) {
    this.repository.setFilterByName(filterByName);
  }

  onDelete(item: ZipHistoryItem) {
    this.zipDelete
      .delete(item)
      .pipe(mergeMap(() => this.service.fetchZipHistory()))
      .subscribe();
  }
}
